import * as tslib_1 from "tslib";
// Core packages
import { OnDestroy, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
// Third party packages
import { MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from "ngx-toastr";
import { finalize } from "rxjs/operators";
// Custom packages
import { PlatformNotesService } from 'src/app/components/platform-note-card/platformNotes.service';
import { AuthService } from "src/app/modules/auth/auth.service";
import { PropertiesService } from "src/app/modules/properties/properties.service";
import { User } from "src/app/shared/models/user/user.model";
import { ApiService } from "src/app/shared/services/api.service";
import { ConfigService } from "src/app/shared/services/config.service";
import { HelperService } from "src/app/shared/services/helper.service";
var AssociatePropertiesPlatformNoteDialogComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function AssociatePropertiesPlatformNoteDialogComponent(dialogRef, data, configService, toastrService, cookieService, translateService, helperService, authService, apiService, platformNotesService, propertiesService) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.configService = configService;
        this.toastrService = toastrService;
        this.cookieService = cookieService;
        this.translateService = translateService;
        this.helperService = helperService;
        this.authService = authService;
        this.apiService = apiService;
        this.platformNotesService = platformNotesService;
        this.propertiesService = propertiesService;
        this.subscriptions = [];
        this.user = new User();
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        // BEGIN - Add subUser form
        // BEGIN - ngx-formly
        this.form = new FormGroup({});
        this.model = {};
        this.fields = [];
        this.options = {};
        // END - ngx-formly
        this.formBtnOptions = {
            active: false,
            text: this.translateService.instant("common.cta.confirm"),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: "primary",
            spinnerColor: "primary",
            fullWidth: false,
            disabled: false,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-save",
                inline: true
            }
        };
        // END - Add subUser form
        this.dialogIsLoading = true;
        this.properties = [];
        this.selectAll = false;
        this.filterProperty = "";
        dialogRef.disableClose = true;
    }
    /**
     * Init component
     *
     */
    AssociatePropertiesPlatformNoteDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Get logged user data
        this.subscriptions.push(this.authService.loggedUser$.subscribe(function (res) { return (_this.loggedUser = res); }));
        // Get current lang
        this.lang =
            this.cookieService.get("lang") || this.configService.defaultLang;
        // Init data
        if (this.data) {
            if (typeof this.data.allProperties !== "undefined") {
                this.selectAll = this.data.allProperties;
            }
        }
        // View data
        this.subscriptions.push(this.propertiesService.getCompanyProperties(this.data.companyId).subscribe(function (res) {
            var e_1, _a;
            if (res.status) {
                // Backend v2 returns the properties as a plain array in `data`.
                // Keep the legacy `data.items` shape as a fallback for safety.
                var items = res.data && Array.isArray(res.data)
                    ? res.data
                    : (res.data && Array.isArray(res.data.items) ? res.data.items : []);
                try {
                    for (var items_1 = tslib_1.__values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
                        var item = items_1_1.value;
                        _this.properties.push({
                            id: item._id,
                            name: item.name,
                            value: _this.data.properties && _this.data.properties.includes(item._id.toString()) ? true : false,
                            visible: true,
                        });
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                _this.properties.sort(function (a, b) { return a.name.localeCompare(b.name); });
                return;
            }
        }, function (err) {
            // if we came here company do not exists
            _this.helperService.handleError(err);
        }));
        // Stop loading dialog
        this.dialogIsLoading = false;
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    AssociatePropertiesPlatformNoteDialogComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Handle dialog closing
     *
     * @since 1.0.0
     */
    AssociatePropertiesPlatformNoteDialogComponent.prototype.onClose = function (data) {
        this.dialogRef.close(data);
    };
    /**
     * Handle select all properties
     *
     * @since 1.0.0
     */
    AssociatePropertiesPlatformNoteDialogComponent.prototype.onSelectAll = function (checked) {
        this.selectAll = checked;
        if (!checked) {
            this.properties.forEach(function (property) {
                property["value"] = false;
            });
        }
        else if (checked) {
            this.properties.forEach(function (property) {
                property["value"] = true;
            });
        }
    };
    /**
     * Handle form submit
     *
     * @since 1.0.0
     */
    AssociatePropertiesPlatformNoteDialogComponent.prototype.onFormSubmit = function () {
        var _this = this;
        var propertiesSelected = [];
        if (this.properties && Array.isArray(this.properties)) {
            this.properties.forEach(function (item) {
                if (item.value) {
                    propertiesSelected.push(item.id);
                }
            });
        }
        var data = {
            properties: propertiesSelected,
            allProperties: this.selectAll
        };
        this.subscriptions.push(this.platformNotesService
            .updateNote(this.data.noteId, data)
            .pipe(finalize(function () { return (_this.formBtnOptions.active = false); }))
            .subscribe(function (res) {
            if (res.status) {
                _this.toastrService.success(res.message);
                _this.onClose({ status: true });
                return;
            }
            _this.toastrService.error(_this.translateService.instant("common.errors.unknown_server_error"));
        }, function (err) {
            // Choose one of the following error handling method.
            // 1) First one show a message right under the form fields
            //    (if the form is properly setted)
            // 2) Second one is used to show a mat-error under each field
            //    in the dynamic form (is meant to be used only in dynamicForm)
            // 3) Third one show toastr notifications for each error
            // 4) Fourth one is used to show mat-error under each field
            //    in the ngx-formly form (is mean to be used only with ngx-formly)
            // this.helperService.handleFormError(form, err);
            // this.helperService.handleDynamicFormError(form, err);
            // this.helperService.handleError(err);
            _this.helperService.handleFormlyError(_this.form, err);
        }));
    };
    /**
     * Handle properties filtering
     *
     * @since 1.0.0
     */
    AssociatePropertiesPlatformNoteDialogComponent.prototype.onFilterProperties = function () {
        if (this.filterProperty !== '') {
            this.selectAll = false;
        }
        var regex = new RegExp(this.filterProperty.trim().toLowerCase(), "gim");
        this.properties.forEach(function (el) {
            if ((el.name && el.name.search(regex) > -1)) {
                el.visible = true;
            }
            else {
                el.visible = false;
                // el.value = false;
            }
        });
    };
    return AssociatePropertiesPlatformNoteDialogComponent;
}());
export { AssociatePropertiesPlatformNoteDialogComponent };
